const images = {
  logo: require("./logo.png"),
  cart: require("./cart2.png"),
  mobile: require("./slide1.png"),
  slide2: require("./slide3.png"),
  slide3: require("./slide4.png"),
  slide4: require("./pngwing.com (31) 1.png"),
  wholesalerBg: require("./whole-seller-banner.png"),
  repair1: require("./repair1.png"),
  repair2: require("./repair2.png"),
  repair3: require("./repair3.png"),
  repair4: require("./repair4.png"),
  repair5: require("./repair5.png"),
  parts1: require("./parts1.png"),
  parts2: require("./parts2.png"),
  parts3: require("./parts3.png"),
  smartphone1: require("./smartphone1.png"),
  smartphone2: require("./smartphone2.png"),
  smartphone3: require("./smartphone3.png"),
  smartphone4: require("./smartphone4.png"),
  smartwatch1: require("./smartwatch1.png"),
  smartwatch2: require("./smartwatch2.png"),
  smartwatch3: require("./smartwatch3.png"),
  smartwatch4: require("./smartwatch4.png"),
  laptop1: require("./laptop1.png"),
  laptop2: require("./laptop2.png"),
  laptop3: require("./laptop3.png"),
  laptop4: require("./laptop4.png"),
  tab1: require("./tab1.png"),
  tab2: require("./tab2.png"),
  tab3: require("./tab3.png"),
  tab4: require("./tab4.png"),
  xbox1: require("./xbox1.png"),
  xbox2: require("./xbox2.png"),
  xbox3: require("./xbox3.png"),
  xbox4: require("./xbox4.png"),
  service1: require("./repairman.png"),
  service2: require("./service2img.png"),
  service3: require("./service3img.png"),
  map1: require("./map1.png"),
  map2: require("./map2.png"),
  map3: require("./map3.png"),
  map4: require("./map4.png"),
  footerLogo: require("./footerImg.png"),
  facebook: require("./fb.png"),
  instagram: require("./insta.png"),
  whatsapp: require("./wp.png"),
  repairImage1: require("./Property 1=Frame 31.png"),
  repairImage2: require("./Property 1=Variant3.png"),
  repairImage3: require("./Property 1=Variant4.png"),
  repairImage4: require("./Property 1=Frame 32.png"),
  repairImage5: require("./Property 1=Variant5.png"),
  samsung: require("./samsung.png"),
  apple: require("./apple.png"),
  google: require("./Google-pixel.png"),
  motorola: require("./Motorola.png"),
  oneplus: require("./Oneplus.png"),
  issueImg1: require("./Group 1 (1).png"),
  issueImg2: require("./Group 1 (1).png"),
  issueImg3: require("./instagram.png"),
  issueImg4: require("./3full.png"),
  issueImg5: require("./flash.png"),
  location: require("./location.png"),
  brandSlide1: require("./brandSlide1.png"),
  brandSlide2: require("./brandSlide2.png"),
  brandSlide3: require("./brandSlide3.png"),
  brandSlide4: require("./brandSlide4.png"),
  brandSlide5: require("./brandSlide5.png"),
  brandSlide6: require("./brandSlide6.png"),
  brandSlide7: require("./brandSlide7.png"),
  lg: require("./LG.png"),
  card1: require("./card1.png"),
  card2: require("./card2.png"),
  card3: require("./card3.png"),
  card4: require("./card4.png"),
  card5: require("./card5.png"),
  pc1: require("./pc1.png"),
  pc2: require("./pc2.png"),
  pc3: require("./pc3.png"),
  pc4: require("./pc4.png"),
  pc5: require("./pc5.png"),
  pc6: require("./pc6.png"),
  servicesBg: require("./serv.jpg"),
  unlock1: require("./unlock1.png"),
  unlock2: require("./unlock2.png"),
  unlock3: require("./unlock3.png"),
  company1: require("./company1.png"),
  company2: require("./company2.png"),
  company3: require("./company3.png"),
  company4: require("./company4.png"),
  company5: require("./company5.png"),
  company6: require("./company6.png"),
  company7: require("./company7.png"),
  company8: require("./company8.png"),
  company9: require("./company9.png"),
  company10: require("./company10.png"),
  company11: require("./company11.png"),
  company12: require("./company12.png"),
  slide5: require("./banner5.png"),
  slide6: require("./whole-seller-banner.png"),
  pcbuild1: require("./pcbuild1.png"),
  pcbuild2: require("./pcbuild2.png"),
  pcbuild3: require("./pcbuild3.png"),
  pcbuild4: require("./pcbuild4.png"),
  check: require("./tick-square.png"),
  zelle: require("./zelle.png"),
  cashApp: require("./cashapp.png")
};

export default images;